module.exports = __webpack_public_path__ + "static/media/day-night.00f3547a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/day-night.svg
// module id = 2723
// module chunks = 7